import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledPopularProducts = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.brightGrey};

  .title {
    h1 {
      font-family: ${(props) => props.theme.fontText};
    }
  }

  .grid-view {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 20px;
    justify-content: center;
    justify-items: center;
  }

  @media only screen and (min-width: ${breakpoints.lg}px) and (max-width: 1450px) {
    .grid-view {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  @media only screen and (max-width: ${breakpoints.md}px) {
    .title {
      padding: 1em 0 0 0;
      h1 {
        font-size: 1.5rem !important;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    .grid-view {
      grid-template-columns: 1fr;
      gap: 12px;
    }
  }
`;
